import {roleSystemRoute} from './route_utilities'

import Projects from '../../views/projects/Projects.vue'
import CreateProject from '../../views/projects/CreateProject.vue'
import Project from '../../views/projects/Project.vue'
import ProjectGeneral from '../../views/projects/ProjectGeneral.vue'
import ProjectConditions from '../../views/projects/ProjectConditions.vue'
import ProjectCondition from '../../views/projects/ProjectCondition.vue'
import ProjectTranslations from '../../views/projects/ProjectTranslations.vue'
import ProjectSuppliers from '../../views/projects/ProjectSuppliers.vue'
import ProjectUsers from '../../views/projects/ProjectUsers.vue'
import CreateProjectFlow from '../../views/projects/CreateProjectFlow.vue'
import ProjectFlows from '../../views/projects/ProjectFlows.vue'
import ProjectStatus from '../../views/projects/ProjectStatus.vue'
import ProjectCustomAttributes from '../../views/projects/ProjectCustomAttributes.vue'
import ProjectPeriods from '../../views/projects/ProjectPeriods.vue'
import CreateProjectPeriod from '../../views/projects/CreateProjectPeriod.vue'
import ProjectPeriod from '../../views/projects/ProjectPeriod.vue'
import ProjectNonconformities from '../../views/projects/ProjectNonconformities.vue'



export const projects = {
      path: 'projects',
      name: 'Projects',
      component: Projects,
      meta: {
          title: "projeler",
          domain:"projects",
          accessroles:["admin","brand","auditor","planner"],
        },
      }


export const create_project = {
      path: 'project',  
      name: 'CreateProject',
      component: CreateProject,
      meta: {
          title: "yeni_proje",
          preloader:true,
          domain:"projects",
          accessroles:["admin","brand","auditor","planner"],
        },
      }
export const project = {
      path: 'project/:id',  
      name: 'Project',
      component: Project,
      redirect: { name: 'ProjectStatus' },
      meta: {
          title: "proje",
          preloader:true,
          domain:"projects",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
          {
          path: 'general',  
          name: 'ProjectGeneral',
          component: ProjectGeneral,
          meta: {
              title: "proje_genel",
              preloader:true,
              domain:"projects"
            },
          }, 
          {
          path: 'conditions',  
          name: 'ProjectConditions',
          component: ProjectConditions,
          meta: {
              title: "proje_kosullari",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'condition',  
          name: 'CreateProjectCondition',
          component: ProjectCondition,
          meta: {
              title: "proje_kosulu",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'condition/:condition_id',  
          name: 'ProjectCondition',
          component: ProjectCondition,
          meta: {
              title: "proje_kosulu",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'translations',  
          name: 'ProjectTranslations',
          component: ProjectTranslations,
          meta: {
              title: "proje_cevirileri",
              preloader:true,
              domain:"projects"
            },
          },          
          {
          path: 'project_nonconformities',  
          name: 'ProjectNonconformities',
          component: ProjectNonconformities,
          meta: {
              title: "uygunsuzluklar",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'suppliers',  
          name: 'ProjectSuppliers',
          component: ProjectSuppliers,
          meta: {
              title: "proje_tedarikcileri",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'periods',  
          name: 'ProjectPeriods',
          component: ProjectPeriods,
          meta: {
              title: "proje_donemleri",
              preloader:true,
              domain:"projects"
            },
          }, 
           {
          path: 'new_period',  
          name: 'CreateProjectPeriod',
          component: CreateProjectPeriod,
          meta: {
              title: "yeni_proje_donemi",
              preloader:true,
              domain:"projects"
            },
          },

           {
          path: 'period/:period_id',  
          name: 'ProjectPeriod',
          component: ProjectPeriod,
          meta: {
              title: "proje_donemi",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'flows',  
          name: 'ProjectFlows',
          component: ProjectFlows,
          meta: {
              title: "proje_akislari",
              preloader:true,
              domain:"projects"
            },
          }, 
           {
          path: 'flow',  
          name: 'CreateProjectFlow',
          component: CreateProjectFlow,
          meta: {
              title: "yeni_proje_akisi",
              preloader:true,
              domain:"projects"
            },
          },
          {
          path: 'status',  
          name: 'ProjectStatus',
          component: ProjectStatus,
          meta: {
              title: "proje_durumu",
              preloader:true,
              domain:"projects"
            },
          }, {
          path: 'custom_attributes',  
          name: 'ProjectCustomAttributes',
          component: ProjectCustomAttributes,
          meta: {
              title: "ozel_nitelikler",
              preloader:true,
              domain:"projects"
            },
          },   


          {
          path: 'users',  
          name: 'ProjectUsers',
          component: ProjectUsers,
          meta: {
              title: "Proje Kullanıcıları",
              preloader:true,
              domain:"projects"
            },
          },
        ]
      }
